export var CampaignStatusMapEnum;
(function (CampaignStatusMapEnum) {
    CampaignStatusMapEnum["ACTIVE"] = "Active";
    CampaignStatusMapEnum["INACTIVE"] = "Inactive";
    CampaignStatusMapEnum["BOOKED"] = "Booked";
    CampaignStatusMapEnum["EXPIRED"] = "Expired";
    CampaignStatusMapEnum["EXHAUSTED"] = "Exhausted";
    CampaignStatusMapEnum["STOPPED"] = "Stopped";
    CampaignStatusMapEnum["INVALID"] = "Invalid";
})(CampaignStatusMapEnum || (CampaignStatusMapEnum = {}));
export const AD_GROUP_INDEX = 0;
